import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import './BrandCarousel.css';
import { Typography, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const airesCampo = require('../../assets/img/marcarcarousel/airesdecampo-logo.png');
const barilla = require('../../assets/img/marcarcarousel/barilla-logo.png');
const bettyCrocker = require('../../assets/img/marcarcarousel/bettycrocker-logo.png');
const blason = require('../../assets/img/marcarcarousel/blason-logo.png');
const bufalo = require('../../assets/img/marcarcarousel/bufalo-logo.png');
const chilimBalam = require('../../assets/img/marcarcarousel/chilimbalam-logo.png');
const cholula = require('../../assets/img/marcarcarousel/cholula-logo.png');
const delFuerte = require('../../assets/img/marcarcarousel/delfuerte-logo.png');
const donaMaria = require('../../assets/img/marcarcarousel/donamaria-logo.png');
const embasa = require('../../assets/img/marcarcarousel/embasa-logo.png');
const flaveur = require('../../assets/img/marcarcarousel/flaveur-logo.png');
const franksRedHoy = require('../../assets/img/marcarcarousel/franksredhoy-logo.png');
const herdez = require('../../assets/img/marcarcarousel/herdez-logo.png');
const herdez8 = require('../../assets/img/marcarcarousel/herdez8-logo.png');
const kikkoman = require('../../assets/img/marcarcarousel/kikkoman-logo.png');
const libanius = require('../../assets/img/marcarcarousel/libanius-logo.png');
const mccormick = require('../../assets/img/marcarcarousel/mccormick-logo.png');
const mielcarlota = require('../../assets/img/marcarcarousel/mielcarlota-logo.png');
const naturevalley = require('../../assets/img/marcarcarousel/naturevalley-logo.png');
// const nestle = require('../../assets/img/marcarcarousel/nestle-logo.png');
const nutrisa = require('../../assets/img/marcarcarousel/nutrisa-logo.png');
const reynolds = require('../../assets/img/marcarcarousel/reynolds-logo.png');
const srcactus = require('../../assets/img/marcarcarousel/srcactus-logo.png');
const yemina = require('../../assets/img/marcarcarousel/yemina-logo.png');
const frenchs = require('../../assets/img/marcarcarousel/frenchs-logo.png');

const brands = [
  { name: 'Aires de Campo', image: airesCampo, url: 'https://airesdecampo.com/' },
  { name: 'Barilla', image: barilla, url: 'https://www.momentosbarilla.com/' },
  { name: 'Betty Crocker', image: bettyCrocker, url: 'https://www.bettycrocker.lat/mx/' },
  { name: 'Blason', image: blason, url: 'https://cafeblason.mx/' },
  { name: 'Bufalo', image: bufalo, url: 'https://bufalo.com.mx/' },
  { name: 'Chilim Balam', image: chilimBalam, url: '' },
  { name: 'Cholula', image: cholula, url: 'https://salsacholula.com.mx/' },
  { name: 'Del Fuerte', image: delFuerte, url: 'https://delfuerte.com/' },
  { name: 'Doña Maria', image: donaMaria, url: 'https://donamaria.com.mx/' },
  { name: 'Embasa', image: embasa, url: 'https://embasa.com.mx/' },
  { name: 'Flaveur', image: flaveur, url: 'https://flaveur.com.mx/' },
  { name: 'Franks Red Hoy', image: franksRedHoy, url: 'https://franksredhot.com.mx/' },
  { name: 'Herdez', image: herdez, url: 'https://www.herdez.com.mx/' },
  { name: 'Herdez 8', image: herdez8, url: 'https://www.herdez8.com/' },
  { name: 'Kikkoman', image: kikkoman, url: 'https://kikkoman.com.mx/' },
  { name: 'Libanius', image: libanius, url: 'https://libanius.com.mx/' },
  { name: 'Mc Cormick', image: mccormick, url: 'https://www.mccormick.mx/' },
  { name: 'Miel Carlota', image: mielcarlota, url: 'https://www.mielcarlota.com.mx/' },
  { name: 'Nature Valley', image: naturevalley, url: 'https://www.naturevalley.com.mx/' },
  // { name: 'Nestle', image: nestle, url: 'https://airesdecampo.com/' },
  { name: 'Nutrisa', image: nutrisa, url: 'https://www.nutrisa.com/' },
  { name: 'Reynolds', image: reynolds, url: 'https://www.reynolds.com.mx/' },
  { name: 'Sr. Cactus', image: srcactus, url: 'https://www.senorcactus.com.mx/' },
  { name: 'Yemina', image: yemina, url: '' },
  { name: 'Frenchs', image: frenchs, url: 'https://airesdecampo.com/' },

];

const BrandCarousel = (_props: { showTitle?: boolean }) => (
  <div className="brand-carousel-container">
    
          <Typography className="brand-carousel-title">Nuestras marcas</Typography>

    <div className="brand-carousel-wrapper">
      {['basic-marquee-1'].map((cl, i) => (
        <div key={cl} className={`basic-marquee ${cl}`}>
          {brands
            // triplicamos el array para asegurar continuidad en pantallas grandes
            .concat(brands).concat(brands)
            .map((b, idx) => (
              <a
                key={idx}
                href={b.url}
                className="brand-carousel-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="brand-carousel-image"
                  src={b.image}
                  alt={b.name}
                />
              </a>
            ))}
        </div>
      ))}
    </div>
  </div>
);

export default BrandCarousel;